import { type LevelConfig } from "../../types/gamification/level";

/**
 * Literal level numbers for UI / badge props. Keep in sync with `LEVEL_CONFIGS`
 * (extend this tuple when adding a level — see level.test.ts).
 */
export const GAMIFICATION_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

export type GamificationLevel = (typeof GAMIFICATION_LEVELS)[number];

/**
 * Progressive level thresholds (10 levels). Aligns with gamification product docs.
 */
export const LEVEL_CONFIGS: readonly LevelConfig[] = [
  { level: 1, pointsRequired: 0 },
  { level: 2, pointsRequired: 100 },
  { level: 3, pointsRequired: 300 },
  { level: 4, pointsRequired: 600 },
  { level: 5, pointsRequired: 1000 },
  { level: 6, pointsRequired: 1500 },
  { level: 7, pointsRequired: 2200 },
  { level: 8, pointsRequired: 3000 },
  { level: 9, pointsRequired: 4000 },
  { level: 10, pointsRequired: 5500 },
];

/** Highest configured level (keep all checks in sync with LEVEL_CONFIGS). */
export const MAX_GAMIFICATION_LEVEL = LEVEL_CONFIGS.length;

export const isGamificationLevel = (value: number): value is GamificationLevel =>
  (GAMIFICATION_LEVELS as readonly number[]).includes(value);
